import { useState, useEffect } from "react";
import { ConfigProvider, theme, BackTop } from "antd";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import mnMN from "antd/locale/mn_MN";
import "dayjs/locale/mn";
import { AppStore } from "context/AppContext";
import { ThemeSwitcher, SmoothScroll } from "components";
import LoginPage from "views/Auth/Login";
import ForgotPassword from "views/Auth/ForgotPassword";
import AppLayout from "layout";
import { auth } from "api/endpoints";
import "api/interceptor";
import "./App.css";
import AuthVerify from "api/authVerify";
import useWindowWidth from "hooks/useWindowWidth";
import dayjs from "dayjs";

const themeseses = {
  dark: {
    algorithm: theme.darkAlgorithm,
  },
  light: {
    algorithm: theme.defaultAlgorithm,
  },
};
dayjs.locale("mn");

function App() {
  const [myTheme, setMyTheme] = useState(themeseses.dark);

  const darkMode = JSON.parse(localStorage.getItem("darkMode") ?? false);

  const { windowWidth } = useWindowWidth();

  useEffect(() => {
    if (darkMode) {
      setMyTheme(themeseses.dark);
    } else {
      setMyTheme(themeseses.light);
    }
  }, []);

  return (
    <ConfigProvider
      theme={{
        ...myTheme,
        token: {
          colorPrimary: "#2396BE",
          colorLink: "#2396BE",
          ...(windowWidth < 1500 && {
            fontSize: 12,
          }),
        },
      }}
      locale={mnMN}
    >
      <AppStore>
        <BackTop />
        <ThemeSwitcher
          switchTheme={() => {
            if (myTheme === themeseses.dark) {
              setMyTheme(themeseses.light);
            } else {
              setMyTheme(themeseses.dark);
            }
          }}
        />
        <Router>
          <SmoothScroll>
            <Routes>
              <Route path={"*"} element={<AppLayout />} />
              <Route path={auth.login} element={<LoginPage />} />
              <Route path={"/forgot-password"} element={<ForgotPassword />} />
            </Routes>
          </SmoothScroll>
          <AuthVerify />
        </Router>
      </AppStore>
    </ConfigProvider>
  );
}

export default App;
